import { inputDescLimit, inputTextLimit, radiusLimit } from '../../../helpers/inputTextLimit';
import messages from '../../../locale/messages'

const validate = values => {

  const errors = {};

  const textFieldValidation = { textLimit: true };

  const formFields = [
    { fieldName: 'stripePublishableKey', validation: textFieldValidation }, // Stripe
    { fieldName: 'stripeSecretKey', validation: textFieldValidation },
    { fieldName: 'twillioAccountSid', validation: textFieldValidation }, // Twilio
    { fieldName: 'twillioAuthToken', validation: textFieldValidation },
    { fieldName: 'twillioPhone', validation: textFieldValidation },
    { fieldName: 'maxDistance', validation: { numeric: true, maxRadiusLimit: true } }, // Distance
    { fieldName: 'fcmPushNotificationKey', validation: {textAreaLimit: true } }, // FCM
    { fieldName: 'paystackSecretKey', validation: textFieldValidation }, // PayStack
    { fieldName: 'eversendClientID', validation: textFieldValidation }, //Eversend
    { fieldName: 'eversendSecretKey', validation: textFieldValidation },
    { fieldName: 'eversendWebhookSecretKey', validation: textFieldValidation }
  ];


  formFields && formFields.map((field) => {
    // Required Validation
    if (!values[field.fieldName]) {
      errors[field.fieldName] = messages.required;
    } else if (values[field.fieldName] && values[field.fieldName].toString().trim() == "") {
      errors[field.fieldName] = messages.required;
    }
    // Numeric Validation
    if (!errors[field?.fieldName] && field?.validation && field?.validation?.numeric
      && isNaN(values[field?.fieldName])) {
      errors[field.fieldName] = messages.numericValue;
    }
    // Text field character limit validation
    if (!errors[field?.fieldName] && field?.validation && field?.validation?.textLimit
      && values[field?.fieldName].length > inputTextLimit) {
      errors[field.fieldName] = messages.inputFieldLimitError;
    }
    // TextArea field character limit validation
    if (!errors[field?.fieldName] && field?.validation && field?.validation?.textAreaLimit
      && values[field?.fieldName].length > inputDescLimit) {
      errors[field.fieldName] = messages.inputFieldLimitError;
    }
    // Radius field character limit validation
    if (!errors[field?.fieldName] && field?.validation && field?.validation?.maxRadiusLimit
      && values[field?.fieldName].length > radiusLimit) {
      errors[field.fieldName] = messages.fifteenNumbersAllowed;
    }
  });

  return errors
}

export default validate;
